const config = {
	CDN_ASSETS: `${process.env.REACT_APP_CDN}/assets/` || 'localhost',
	CDN_MEDIA: `${process.env.REACT_APP_CDN}/media/` || 'localhost',
	DEEPLINK_URL: process.env.REACT_APP_DEEPLINK_URL || 'localhost',
};

export default config;